module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_hometown@2x-b097c3744d7927342fa64d171b21fe32.webp";